export const traverseTree = (tree, callback) => {
  // 递归遍历树中的每个节点
  function traverse(nodes) {
    nodes.forEach(node => {
      callback(node) // 执行回调函数
      if (node.children && node.children.length) {
        traverse(node.children) // 递归子节点
      }
    })
  }
  traverse(tree) // 开始遍历
}

export function findAndModifyTreeNode(treeData, nodeId, modifier) {
  // 递归函数来查找并修改树中的节点
  function recursiveFindAndModify(nodes) {
    if (nodes && nodes.length) {
      nodes.forEach(node => {
        if (node.id === nodeId) {
          modifier(node) // 修改节点
        } else {
          recursiveFindAndModify(node.children)
        }
      })
    }
  }
  recursiveFindAndModify([...treeData])
}
export function treeToArray(treeData) {
  let result: any = []
  if (treeData && treeData.length) {
    treeData.forEach((item: any) => {
      result.push(item)
      if (item.children && item.children.length) {
        result = result.concat(treeToArray(item.children))
      }
    })
  }
  return result
}
